// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label-404 {
  font-size: 24px;
  margin-bottom: 30px;
  padding-left: 20px;
}
.options {
  padding-left: 20px;
}
`, "",{"version":3,"sources":["webpack://./node_modules/proceduralsystem-clientcomponents/components/not-found/not-found.component.less"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,mBAAA;EACA,kBAAA;AACJ;AAEA;EACI,kBAAA;AAAJ","sourcesContent":[".label-404 {\n    font-size: 24px;\n    margin-bottom: 30px;\n    padding-left: 20px;\n}\n\n.options {\n    padding-left: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
